import dji from './dji';
import etc from './etc';
import mavlink from './mavlink';

const commandSet = {};
dji.forEach((command) => {
  commandSet[command.id] = command;
});
etc.forEach((command) => {
  commandSet[command.id] = command;
});
mavlink.forEach((command) => {
  commandSet[command.id] = command;
});

export default commandSet;
